import React from 'react';
import PropTypes from 'prop-types';
import { Box, Text } from '@stitch-fix/mode-react';

/**
 * This component displays a product's long-form description
 */
const ProductDescription = ({ text }) => {
  return (
    <Box>
      <Text setting="body-small" mt={{ sm: 1, lg: 1.5 }}>
        {text}
      </Text>
    </Box>
  );
};

ProductDescription.propTypes = {
  text: PropTypes.string.isRequired,
};

export default ProductDescription;
